import React, { useEffect, useCallback, useState } from "react";
import {
  Container, Row, Col, Card, CardBody, Form, Toast,
  ToastBody,
  ToastHeader
} from "reactstrap";
import { logUser, apiError } from "../../store/auth/login/actions.js";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";



const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({
    email: "",
    password: "",
    message: "",
  });
  const [isLoginPressed, setIsLoginPressed] = useState(false);
  document.title = "Login | iXimanager";
  useEffect(() => {
    document.body.className = "bg-pattern";
    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
    };
  });


  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const loginState = useSelector((state) => state.login);

  const showSuccess = (message) => {
    setShowErrorToast(false);
    setToastMessage(message);
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 3000);
  };

  const showError = (message) => {
    setShowSuccessToast(false);
    setToastMessage(message);
    setShowErrorToast(true);
    setTimeout(() => setShowErrorToast(false), 3000);
  };


  const validateForm = useCallback(() => {
    let newErrors = {};

    if (!email) {
      newErrors.email = "Email is required";
    }

    if (!password) {
      newErrors.password = "Password is required";
      showError("Password is required");
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  }, [email, password]);

  const onLoginPress = useCallback(async () => {
    setIsLoginPressed(true);
    if (validateForm()) {
      try {
        const userData = { email: email, password: password };
        dispatch(logUser(userData, navigate));
        setErrors({});
      } catch (error) {
        if (error instanceof Error) {
          console.log("Registration failed:", error.message);
          setErrors({ ...errors, message: error.message });
          showError("" + error.message);
        }
      }
    }
  }, [validateForm, email, password, dispatch, errors]);
  // show toast when login error occurs
  useEffect(() => {
    if (loginState && loginState.error) {
      // inspect shape if not simple string
      if (typeof loginState.error !== "string" && !loginState.error.message) {
        console.log("loginState.error object:", loginState.error);
      }
      const msg =
        typeof loginState.error === "string"
          ? loginState.error
          : loginState.error.message || "Erreur de connexion";
      showError(msg);
      // clear redux error after showing
      dispatch(apiError(""));
    }
  }, [loginState.error, dispatch]);

  return (
    <React.Fragment>
      <div className="bg-overlay"></div>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} md={8} xl={4}>
              <Card>
                <CardBody className="p-4">
                  <div>
                    <div className="text-center">
                      <img
                        src="/iXiVERSE-LOGO-DrkNoBG.png"
                        alt="test"
                        height="25%"
                        width="25%"
                      />
                      <h3><span style={{ color: "#0944a1", fontWeight: "600" }}>iXi</span>
                        <span style={{ color: "#00d6ff", fontWeight: "600" }}>MANAGER</span></h3>
                    </div>
                    <h4 className="font-size-18 text-muted mt-2 text-center">
                      Welcome Back !
                    </h4>


                    <Form className="form-horizontal" action="#">
                      <Row>
                        <Col md={12}>
                          <div className="mb-4">
                            <label className="form-label" htmlFor="username">
                              Email
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="username"
                              placeholder="Enter email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                          <div className="mb-4">
                            <label
                              className="form-label"
                              htmlFor="userpassword"
                            >
                              Password
                            </label>
                            <input
                              type="password"
                              value={password}
                              className="form-control"
                              id="userpassword"
                              placeholder="Enter password"
                              onChange={(e) => setPassword(e.target.value)}
                            />
                          </div>

                          {/*  <Row>
                            <Col>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customControlInline"
                                />
                                <label
                                  className="form-label form-check-label"
                                  htmlFor="customControlInline"
                                >
                                  Remember me
                                </label>
                              </div>
                            </Col>
                            <Col className="col-7">
                              <div className="text-md-end mt-3 mt-md-0">
                                <Link
                                  to="/auth-recoverpw"
                                  className="text-muted"
                                >
                                  <i className="mdi mdi-lock"></i> Forgot your
                                  password?
                                </Link>
                              </div>
                            </Col>
                          </Row> */}
                          <div className="d-grid mt-4">
                            <button
                              type="button"
                              className="btn btn-primary waves-effect waves-light"
                              onClick={onLoginPress}
                            >
                              Log in
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              {/*   <div className="mt-5 text-center">
                <p className="text-white-50">
                  Don't have an account ?{" "}
                  <Link to="/auth-register" className="fw-medium text-primary">
                    {" "}
                    Register{" "}
                  </Link>{" "}
                </p>
                <p className="text-white-50">
                  © {new Date().getFullYear()} Upzet. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger"></i> by Themesdesign
                </p>
              </div> */}
            </Col>
          </Row>
        </Container>
      </div>
      {/* Toast de succès */}
      <div
        style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 9999,
        }}
      >
        <Toast isOpen={showSuccessToast}>
          <ToastHeader
            icon="success"
            toggle={() => setShowSuccessToast(false)}
            style={{ backgroundColor: '#d4edda', color: '#155724' }}
          >
            Succès
          </ToastHeader>
          <ToastBody style={{ backgroundColor: '#d4edda', color: '#155724' }}>
            {toastMessage}
          </ToastBody>
        </Toast>
      </div>

      {/* Toast d'erreur */}
      <div
        style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 9999,
        }}
      >
        <Toast isOpen={showErrorToast}>
          <ToastHeader
            icon="danger"
            toggle={() => setShowErrorToast(false)}
            style={{ backgroundColor: '#f8d7da', color: '#721c24' }}
          >
            Erreur
          </ToastHeader>
          <ToastBody style={{ backgroundColor: '#f8d7da', color: '#721c24' }}>
            {toastMessage}
          </ToastBody>
        </Toast>
      </div>
    </React.Fragment >
  );
};

export default Login;


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license